import O1HD from "../../engines/gameEngine";
import data_control from "../../engines/libs/data_control";

const {ccclass, property} = cc._decorator;

enum archeryRotation{
    left,
    right
}

@ccclass
export default class archeryRole extends cc.Component {

    @property({type:cc.Sprite,tooltip:"显示图片"})
    showSp:cc.Sprite = null;

    @property({type:cc.SpriteFrame,tooltip:"活着的图片"})
    aliveSp:cc.SpriteFrame = null;

    @property({type:cc.SpriteFrame,tooltip:"死去的图片"})
    deathSp:cc.SpriteFrame = null;

    moveSpeedRadio:number[] = [150,200];

    moveSpeed:number = 0;

    rotation:archeryRotation = archeryRotation.left;

    isDeath:boolean = false;

    start(){
        this.showSp.spriteFrame = this.aliveSp;
        this.setRandPos();
        this.setRandRotation();
        this.setRandSpeed();
        this.move();
    }

    setRandPos(){
        this.node.x = data_control.getRandNumberOfArrayTwo([-150,150]);
    }

    setRandRotation(){
        this.rotation = Math.random() < 0.5 ? archeryRotation.left : archeryRotation.right;
    }

    changeRotation(){
        switch(this.rotation){
            case archeryRotation.left:{
                this.rotation = archeryRotation.right;
                break;
            }
            case archeryRotation.right:{
                this.rotation = archeryRotation.left;
                break;
            }
        }
    }

    setRandSpeed(){
        this.moveSpeed = data_control.getRandNumberOfArrayTwo(this.moveSpeedRadio);
    }

    move(){
        cc.Tween.stopAllByTarget(this.node);
        let targetPosX:number = this.rotation == archeryRotation.left ? -150 : 150;
        let distance:number = Math.abs(targetPosX - this.node.x);
        let needTime:number = distance / this.moveSpeed;
        cc.tween(this.node).to(needTime,{x:targetPosX}).call(()=>{
            this.changeRotation();
            this.setRandSpeed();
            this.move();
        }).start();
    }

    death(){
        O1HD.getManagers().soundMgr.playSound("death");
        cc.Tween.stopAllByTarget(this.node);
        this.node.getComponent(cc.Collider).enabled = false;
        this.showSp.spriteFrame = this.deathSp;
        this.isDeath = true;
    }

    alive(){
        this.move();
        this.node.getComponent(cc.Collider).enabled = true;
        this.showSp.spriteFrame = this.aliveSp;
        this.isDeath = false;
    }

}
